import React, {Component} from 'react';
import {Col, Row, UncontrolledTooltip} from "reactstrap";
import {getMemberImage, request} from "../../util/APIUtils";
import {b64toBlob, deepCopyObject, filterTransactionTypes, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL, SERVER_IMAGE_PATH} from "../../constants";
import './Payment.css';
import {Button, DatePicker, input} from "antd";
import Select from "../../local_node_modules/react-select"
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import Dropzone from "react-dropzone";
import moment from "moment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Maskedinput from "react-text-mask";
import FileSaver from "file-saver";
import LoadingIndicator from "../../common/LoadingIndicator";
import locale from "antd/es/date-picker/locale/tr_TR";

class PaymentForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			mode: 'create',
			page: 0,
			size: 10,
			manual: false,
			loading: false,
			fieldsDisabled:false,
			isLoading:false,
			isNotOwner:false,
			payment: {
				id:null,
				isCancelled:null,
				transactionTitle:null,
				transactionDefinition:null,
				transactionDate:null,
				amount:null,
				onlineTransactionCode:null,
				userId:null,
				transactionTypeId:null,
				transactionChannelId:null,
				accrualId:null,
				branchId:null,
				receivedBy:null,
				financialTransactionFileList: [],
				transactionItemList:[{
					id:null,
					itemDetail:null,
					amount: null,
					transactionChannelId:"1",
					financialTransactionId:null
				}],
			}
		};

		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.savePayment = this.savePayment.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.onDrop=this.onDrop.bind(this);
		this.onChangePaymentAmount=this.onChangePaymentAmount.bind(this);
		this.onChangePayment=this.onChangePayment.bind(this);
		this.saveFile=this.saveFile.bind(this);
		this.downloadOriginalFile=this.downloadOriginalFile.bind(this);
		this.onChangeItemAmount = this.onChangeItemAmount.bind(this);
		this.addItem = this.addItem.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.onChangeItem = this.onChangeItem.bind(this);
		this.onItemSelectChange = this.onItemSelectChange.bind(this);
		this.calculate =this.calculate.bind(this);

	}

	 componentDidMount() {
		if (this.props.selectedPayment) {
			let selectedPayment = deepCopyObject(this.props.selectedPayment);
			this.setState({isCancelled: selectedPayment.isCancelled});
			let isNotOwner=(this.props.currentUser.realm!==this.props.selectedPayment.branchId)? true : false;
			let mod = deepCopyObject(this.props.mode);
			selectedPayment.transactionDate = (selectedPayment.transactionDate !== null) ?
				moment.utc(selectedPayment.transactionDate, "YYYY-MM-DD HH:mm:ss")
				: null;

			this.setState({
				mode: mod,
				payment: selectedPayment, isNotOwner,
			})
		}
	}

	onItemSelectChange(name,value,index){
		let payment = this.state.payment;
		let items = payment.transactionItemList;
		if(value===null) {
			items[index][name]=null}
		else {
			items[index][name]=value.value;
		}
		this.setState({payment});

	}

	addItem(){
		let payment=this.state.payment;
		if(payment.transactionItemList.length<3) {
			payment.transactionItemList.push({id:null, itemDetail:null, amount: null, transactionChannelId:"1", financialTransactionId:null, transactionTypeId:null});
			this.setState({payment});
		}
	}

	removeItem(){
		let payment=this.state.payment;
		if(payment.transactionItemList.length>1) {
			payment.transactionItemList.pop(payment.transactionItemList);
			this.setState({payment},()=>this.calculate());
		}
	}

	calculate() {
		let totalAmount=0;
		let payment=this.state.payment;
		for(let i=0;i<payment.transactionItemList.length;i++)
		{
			let val=payment.transactionItemList[i].amount ? payment.transactionItemList[i].amount.toString().replace(',','.') : 0;
			totalAmount=( parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
		}
		payment.amount=parseFloat(totalAmount);
		this.setState({payment});
	}

	onChangeItemAmount(e,index) {
		let totalAmount=0;
		let payment=this.state.payment;
		payment.transactionItemList[index][e.target.name]=e.target.value.toString().substring(0,e.target.value.length-2);
		for(let i=0;i<payment.transactionItemList.length;i++)
		{
			let val=payment.transactionItemList[i].amount ? payment.transactionItemList[i].amount.toString().replace(',','.') : 0;
			totalAmount=( parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
		}
		payment.amount=parseFloat(totalAmount);
		this.setState({payment});
	}

	onChangeItem(e,index) {
		let payment=this.state.payment;
		payment.transactionItemList[index][e.target.name]=e.target.value;
		this.setState({payment});
	}


	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
		let result = validateField(rule, boundary, value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangePayment(e) {
		this.setState({
			payment: {
				...this.state.payment,
				[e.target.name]: e.target.value
			}
		})
	}

	onChangePaymentAmount(e) {
		this.setState({
			payment: {
				...this.state.payment,
				[e.target.name]: e.target.value.toString().substring(0,e.target.value.length-2)
			}
		})
	}

	onChangePaymentDate(name,value) {
		let payment=this.state.payment;
		if(value instanceof moment){
			value = moment.utc(value.format('DD.MM.YYYY').toString() +" 00:00", "DD.MM.YYYY HH:mm");
		}
		payment[name]=value;
		this.setState({ payment });
	}

	onSelectChange(name,value){
		let payment=this.state.payment;
		if(value===null) {
			payment[name]=null}
		else {
			payment[name]=value.value;
		}
		this.setState({payment });

	}

	onChangeEmail(e) {
		this.setState({
			payment: {
				...this.state.payment,
				[e.target.name]: e.target.value
			}
		})
	}


	savePayment() {
		let self = this;
		let params;
		let data;
		let message;
		let payment = deepCopyObject(this.state.payment);
		let validity = this.validateComponent();
		let fileExists=false;
		if(payment.financialTransactionFileList.length>0)
		{
			fileExists=true;
		}
		if (validity.valid && fileExists){
			self.setState({isLoading:true});
			payment.userId=this.props.currentUser.id;
            payment.branchId=this.props.currentUser.realm;
			payment=trimObject(payment);
			payment.amount=payment.amount.toString().replace(',','.');
			for(const item of payment.transactionItemList)
			{
				item.amount=item.amount.toString().replace(',','.');
			}
			data = payment;
			if (payment.id === null) {
				message = 'Gider Başarıyla Kaydedildi.'
				params = {
					url: API_BASE_URL + "/financial-transaction",
					data: data,
					method: 'post'
				};
			} else {
				message = 'Gider Başarıyla Güncellendi.'
				params = {
					url: API_BASE_URL + "/financial-transaction",
					data: data,
					method: 'patch'
				};
			}
			request(params).then(() => {
				Alert.success(
					message, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				self.setState({isLoading:false});
				this.cancelProcess();
				self.props.handleSearch(self.props.searchQuery,true);
			}).catch(function (error) {
				self.setState({isLoading:false});
				showAxiosError(error);
			});
		}
		else{
			let message='Hatalı veya eksik alanlar var!';
			if(!fileExists)
			{message=message +'</br> Gider Dosyası Seçiniz'}
			Alert.error(message, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}


	cancelProcess() {
		this.props.cancelProcess();
	}

	cancelReceipt = () => {
		let params;
		let message;
		let payment = deepCopyObject(this.state.payment);
		let id = payment.id;

		message = 'Gider İptal Edildi.';
		params = {
			url: API_BASE_URL+'/financial-transaction/cancel/' + id,
			data: '',
			method: 'post'
		};

		request(params).then(() => {
			Alert.success(
				message, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			this.setState({isLoading:false});
			this.cancelProcess();
		}).catch(function (error) {
			showAxiosError(error);
		});
	};

	revertCancelReceipt = () => {
		let params;
		let message;
		let payment = deepCopyObject(this.state.payment);
		let id = payment.id;

		message = 'Gider İptali Geri Alındı.';
		params = {
			url: API_BASE_URL + '/financial-transaction/revert/' + id,
			data: '',
			method: 'post'
		};

		request(params).then(() => {
			Alert.success(
				message, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			this.setState({isLoading: false});
			this.cancelProcess();
		}).catch(function (error) {
			showAxiosError(error);
		});
	};

	getBase64(file) {
		return new Promise((resolve,reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = _ => resolve(reader.result);
			reader.onerror = e => reject(e);
		});
	}


    async onDrop(acceptedFiles, rejectedFiles) {
        let self = this;
        let payment_=this.state.payment;
		payment_.financialTransactionFileList=[];
        if (!!acceptedFiles) {
            self.setState({payment_});
            let fileList = [];
            let content= null;
            let maxLength;
			(acceptedFiles.length>=5)? maxLength=5 : maxLength=acceptedFiles.length;
            for (let i = 0; i < maxLength; i++) {
				content=await self.getBase64(acceptedFiles[i]);
				fileList.push({id:null,financial_transaction_id:payment_.id, content:content, name: acceptedFiles[i].name,});

			}
            payment_.financialTransactionFileList=fileList;
			self.setState({payment_});
        }
    }

	saveFile(index){
		let self=this;
		let fileName;
		let fileData;
		self.setState({isItemLoading:true});
		try{
			fileData=self.state.payment.financialTransactionFileList[index].content.toString().substring(self.state.payment.financialTransactionFileList[index].content.toString().lastIndexOf(',')+1);
			fileName=self.state.payment.financialTransactionFileList[index].name;
			var blob = b64toBlob(fileData,'');
			FileSaver.saveAs(blob, fileName);
			self.setState({isItemLoading:false});
		}catch(error) {
			self.setState({isItemLoading: false});
			showAxiosError(error);
		}
	}

	async downloadOriginalFile(index){
		let self=this;
		let fileName;
		let financialTransactionFileList;
		financialTransactionFileList=self.state.payment.financialTransactionFileList;
		fileName=financialTransactionFileList[index].name;
		if((fileName!==null&&fileName==="")) {
			self.setState({isItemLoading:true});
			await getMemberImage(SERVER_IMAGE_PATH+fileName).then(response => {
				financialTransactionFileList[index].content= response.data.base64File;
				self.setState({financialTransactionFileList});
				var blob = b64toBlob(response.data.base64File,'');
				FileSaver.saveAs(blob, fileName);
				self.setState({isItemLoading: false});
			}).catch(function (error) {
				self.setState({isItemLoading: false});
				showAxiosError(error);
			});
		}
	}

	render() {

		let tTransactionDate=this.state.payment.transactionDate ? {value:this.state.payment.transactionDate} : {};
		let expenseTypes=this.props.transactionTypes?filterTransactionTypes( this.props.transactionTypes,"EXPENSE"):[];
		const numberMask = createNumberMask({
			prefix: '',
			suffix: ' ₺',
			allowDecimal: true,
			decimalSymbol:',',
			includeThousandsSeparator:false,
		});

		return (
			<div className='financial-transaction-form-container'>
				{/* HEADER */}
				{
					(this.state.isLoading)&&
					<div className="loader">
						<LoadingIndicator/>
					</div>
				}
				<div className='card-header'>
					<h4 className="card-title">{this.state.mode === 'create' ? 'Gider Oluştur' : 'Gider Düzenle'}</h4>
				</div>
				{/* EO HEADER */}

				{/* ODA AD -TELEFON ROW */}
				<div className="card-body mt-1">
					<div className="FormRenk col-sm-12">
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Kişi/Şirket Adı *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tTitle')}>
									<input className="form-control"
										   type="text"
										   name="transactionTitle"
										   id="tTitle"
										   data-vlength="1,255"
										   onBlur={this.validateField}
										   ref="tTitle"
										   value={this.state.payment.transactionTitle}
										   onChange={(e) => this.onChangePayment(e)}
									/>
									{this.validateMessage('tTitle') !== "" &&
									<UncontrolledTooltip placement="right" target="tTitle" delay={0}>
										{this.validateMessage("tTitle")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Ödeme Yapan: *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tReceivedBy')}>
									<input className="form-control"
										   type="text"
										   name="receivedBy"
										   id="tReceivedBy"
										   maxLength="255"
										   data-vlength="1,255"
										   onBlur={this.validateField}
										   ref="tReceivedBy"
										   value={this.state.payment.receivedBy}
										   onChange={(e) => this.onChangePayment(e)}
									/>
									{this.validateMessage('tReceivedBy') !== "" &&
									<UncontrolledTooltip placement="right" target="tReceivedBy" delay={0}>
										{this.validateMessage("tReceivedBy")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Tarih: *</label>
							</div>
							<div className="col-sm-5">
								<div className={"form-group" + this.validateClass('tTransactionDate')}>
									<DatePicker {...tTransactionDate}
												locale={locale}
												className="basic-single"
												placeholder="Tarih seçiniz."
												disabled={this.state.fieldsDisabled}
												classNamePrefix="select"
												format= "DD.MM.YYYY"
												isClearable={true}
												isSearchable={true}
												name="transactionDate"
												id="tTransactionDate"
												ref="tTransactionDate"
												//style={{ width: 250 }}
												inputProps={{'vdata': "required"}}
												onChange={(dateString) => this.onChangePaymentDate("transactionDate",dateString)}
									/>
									{this.validateMessage('tTransactionDate') !== "" &&
									<UncontrolledTooltip placement="right" target="tTransactionDate" delay={0}>
										{this.validateMessage("tTransactionDate")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>

						{this.state.payment.transactionItemList&&this.state.payment.transactionItemList.map((transactionItem, index) =>
							<div>
							<div className='col-sm-12 row'>
								<div className="col-sm-3">
									{(index===0)&&<label>Gider Kalemleri*:</label>}
								</div>
								<div className="col-sm-1">
									<label style={{fontWeight:"bold"}}>{index+1+":"}</label>
								</div>
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tItemDetail'+index)}>
										<input className="form-control"
											   placeholder="Açıklama"
											   type="text"
											   name={"itemDetail"}
											   id={"tItemDetail" +index}
											   maxLength="50"
											   data-vlength="1,255"
											   onBlur={this.validateField}
											   ref={"tItemDetail" +index}
											   value={transactionItem.itemDetail}
											   onChange={(e) => this.onChangeItem(e,index)}
										/>
										{this.validateMessage('tItemDetail'+index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tItemDetail"+index} delay={0}>
											{this.validateMessage("tItemDetail"+index)}
										</UncontrolledTooltip>}
									</div>
								</div>
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tTransactionType' +index)}>
										<Select
											className="basic-single"
											classNamePrefix="select"
											placeholder="Gider Tipi Seçiniz."
											name={"tTransactionType" +index}
											//style={{ width: 250}}
											inputProps={{'vdata': "required"}}
											ref={"tTransactionType" +index}
											id={"tTransactionType" +index}
											options={expenseTypes}
											onChange={(value)=>this.onItemSelectChange("transactionTypeId",value,index)}
											value={this.state.payment.transactionItemList[index].transactionTypeId}
										/>
										{this.validateMessage('tTransactionType' +index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tTransactionType"+index} delay={0}>
											{this.validateMessage("tTransactionType" +index)}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							<div className="col-sm-12 row">
									<div className="col-sm-3" />
									<div className="col-sm-1" />
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tTransactionChannel'+index)}>
										<Select
											className="basic-single"
											classNamePrefix="select"
											placeholder="Seçiniz."
											name={"tTransactionChannel" + index}
											//style={{ width: 250}}
											ref={"tTransactionChannel" + index}
											id={"tTransactionChannel" + index}
											inputProps={{'vdata': "required"}}
											options={this.props.transactionChannels}
											onChange={(value)=>this.onItemSelectChange("transactionChannelId",value,index)}
											value={transactionItem.transactionChannelId}
										/>
										{this.validateMessage('tTransactionChannel' +index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tTransactionChannel" + index} delay={0}>
											{this.validateMessage("tTransactionChannel" +index)}
										</UncontrolledTooltip>}
									</div>
								</div>
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tAmount'+index)}>
										<Maskedinput className="form-control"
													 mask={numberMask}
													 type="text"
													 name={"amount"}
													 id={"tAmount"+index}
													 inputProps={{vdata: "required", vlength: '3,12'}}
													 placeholder="________,__₺"
													 onBlur={this.validateField}
													 ref={"tAmount" +index}
													 value={transactionItem.amount&&transactionItem.amount.toString().replace('.',',')+ ' ₺'}
													 onChange={(e) => this.onChangeItemAmount(e,index)}
										/>
										{this.validateMessage('tAmount'+index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tAmount"+index} delay={0}>
											{this.validateMessage("tAmount"+index)}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
							{(this.state.payment.transactionItemList.length!==index+1)&&
							<div className='col-sm-12 row'>
									<div className="col-sm-3"/>
									<div className="col-sm-1"/>
									<div className="col-sm-8">
										<hr/>
									</div>
								</div>}
							</div>
						)}
						<div className='col-sm-12 row'>
							<div className="col-sm-3"/>
							<div className="col-sm-6">
								<button className='add-new-item' onClick={()=>{this.addItem()}} />
								<button className='remove-item' onClick={()=>{this.removeItem()}} />
							</div>

						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Toplam Tutar:</label>
							</div>
							<div className="col-sm-5">
								<div className="kjhkjh">
								</div>
							</div>
							<div className="col-sm-4">
								<Maskedinput className="form-control"
											 mask={numberMask}
											 type="text"
											 disabled={true}
											 name="totalAmount"
											 id="tTotalAmount"
											 placeholder="________,__₺"
											 value={this.state.payment.amount&&this.state.payment.amount.toString().replace('.',',')+ ' ₺'}
								/>
							</div>
						</div>
						<div className='col-sm-12 row mt-2'>
							<div className="col-sm-3">
								<label>Gelir Dosyaları *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tTransactionFile')}>
									<Dropzone
										accept=".pdf, .jpeg, .jpg, .png"
										activeClassName="dropzoneActiveClass"
										className="FormRenk3 col-sm-12"
										multiple={true}
										onDrop={this.onDrop}
										id="tTransactionFile"
									>
										<div className="dropzoneInnerArea row">
											<img  alt="" className="add" src={require('../../icons8-plus-48_blue.png')}/>
											<span className="dropzoneInnerAreaText">Dosya(.pdf, .jpeg, .png) yüklemek için tıklayınız.</span>
										</div>
									</Dropzone>
									<Row>
										<Col sm="12" style={{
											paddingTop: "0px",
											paddingRight: "15px",
											paddingLeft: "15px",
											maxHeight: '500px',
											overflow: "auto"
										}}>
											<table className="" style={{textAlign: 'center', paddingBottom: "5px", width:"100%"}}>
												<thead>
												<tr style={{backgroundColor: '#ebedf0'}}>
													<th width="5%">#</th>
													<th>Dosya Adı</th>
													<th width="10%">Görüntüle</th>
												</tr>
												</thead>
												<tbody>
												{this.state.payment.financialTransactionFileList && this.state.payment.financialTransactionFileList.map((document, index) =>
													<tr key={index + "_" + document.name + "_" }>
														<td>{index + 1}</td>
														<td style={{margin: "0px", textAlign: "left"}}>{<TextOverFlowTooltip text={document.name || "-"} maxLength={30}/>}</td>
														<td style={{margin: "0px"}}>
															{<Button className={this.state.isItemLoading?'preview-button-loading':'preview-button'}
																	 disabled={this.state.isItemLoading}
																	 onClick={async () => {(
																	 	this.state.payment.financialTransactionFileList[index].content!=='') ?
																		 this.saveFile(index)
																		 :
																		 await this.downloadOriginalFile(index)}}
															/>}
														</td>
													</tr>
												)}
												{(this.state.payment.financialTransactionFileList && this.state.payment.financialTransactionFileList.length === 0) &&
												<tr>
													<td colSpan="8">Kayıt bulunamadı</td>
												</tr>
												}

												</tbody>
											</table>
										</Col>
										<Col sm="12">
											<p style={{float: "right"}}>Toplam
												Adet: {this.state.payment.financialTransactionFileList ? this.state.payment.financialTransactionFileList.length : 0}</p>
										</Col>
									</Row>
									{this.validateMessage('tTransactionChannel') !== "" &&
									<UncontrolledTooltip placement="right" target="tTransactionChannel" delay={0}>
										{this.validateMessage("tTransactionChannel")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>

					</div>
				</div>
				{/* CARD FOOTER */}
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"180px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-3"></div>
						{!this.state.isCancelled && <div className='col-sm-4'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#da0710', padding: '10px 40px 10px 20px', width:"180px"}}
									rel="tooltip" className="TekBtn vazgec "
									disabled={this.state.isLoading || this.state.payment.id == null}
									onClick={this.cancelReceipt}>
								Gideri İptal Et
							</button>
						</div> }
						{this.state.isCancelled === true && <div className='col-sm-4'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#2662da', padding: '10px 40px 10px 10px', width:"180px"}}
									rel="tooltip" className="TekBtn vazgec "
									disabled={this.state.isLoading || this.state.payment.id == null}
									onClick={this.revertCancelReceipt}>
								Gider İptali Geri Al
							</button>
						</div> }
						<div className="col-sm-1"></div>
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"180px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									disabled={this.state.fieldsDisabled || this.state.isNotOwner || this.state.isLoading}
									onClick={() => this.savePayment()}>{this.state.mode === 'create' ? 'Kaydet' : 'Güncelle'}
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default PaymentForm;



// WEBPACK FOOTER //
// ./src/page/financial/PaymentForm.js